/**
 * SDK version sent to TSS in `X-Embark-SDK-Version` (tss-api #6, D11): the iframe announces its own build,
 * prefixed so TSS metrics tell it apart from parent SDKs.
 */

export const SDK_VERSION_HEADER = 'X-Embark-SDK-Version'

export const IFRAME_SDK_VERSION = `iframe-${
  (typeof __EMBARK_SDK_VERSION__ !== 'undefined' && __EMBARK_SDK_VERSION__) || 'dev'
}`

export function sdkVersionHeaders(): Record<string, string> {
  return { [SDK_VERSION_HEADER]: IFRAME_SDK_VERSION }
}
